import { createApiSlice } from "@common";
import { CRUD_CONTRACT_TYPE } from "@routes";

const apiConfig = [
  {
    name: "addContractType",
    method: "post",
    url: CRUD_CONTRACT_TYPE,
    stateKey: "message",
  },
  {
    name: "getContractType",
    method: "get",
    url: CRUD_CONTRACT_TYPE,
    stateKey: "data",
  },
  {
    name: "updateContractType",
    method: "put",
    url: CRUD_CONTRACT_TYPE,
    stateKey: "message",
  },
  {
    name: "deleteContractType",
    method: "delete",
    url: CRUD_CONTRACT_TYPE,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
"contractType",
 apiConfig, 
 customReducers);
const contractTypeSlice = slice;

export default contractTypeSlice.reducer;

export const {
  addContractType,
  getContractType,
  updateContractType,
  deleteContractType,
} = thunks;

export const { rowSelect } = actions;
